import React, { FunctionComponent, useCallback } from 'react'
import { Trans, useTranslation } from '../../../utils/convergence'
import { TermLink } from '../../TermLink'
import { Text, useDesignLanguagePerClass, useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'
import { useOpenExistingFacility, useSelectedPaymentType } from '../../../state'
import { PaymentType } from '@afterpay/types'
import styles from './style.module.css'
import { TrackingEvent } from '../../../model/monitoring'
import { useMonitoringWithEnduringEventProperties } from '../../../integrations/monitoring'

export const PaymentTypesTerms: FunctionComponent = () => {
  const { t } = useTranslation()
  const selectedPaymentType = useSelectedPaymentType()
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const openExistingFacility = useOpenExistingFacility()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const linkColor = isArcadeDesignLanguage ? 'Black' : 'Orca'
  const designLanguageStyles = useDesignLanguagePerClass(styles)
  const sendAnalyticsEvent = useCallback((): void => logEvent(TrackingEvent.PRESSED_CL_ENTRY_PAGE_DISCLAIMER_LINK), [logEvent])

  const components = {
    terms: (
      <TermLink
        key='payment-options-terms'
        fontFace='CashSansMono'
        href={t('consumerLending:termsOfServiceUrl')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
        color={linkColor}
      />
    ),
    privacy: (
      <TermLink
        key='payment-options-privacy'
        fontFace='CashSansMono'
        href={t('common:privacyPolicyUrl')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
        color={linkColor}
      />
    ),
    febPrivacy: (
      <TermLink
        key='payment-options-feb-privacy'
        fontFace='CashSansMono'
        href={t('consumerLending:febPrivacyPolicyUrl')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
        color={linkColor}
      />
    ),
    creditReportAuthorization: (
      <TermLink
        key='payment-options-credit-report-authorization'
        fontFace='CashSansMono'
        href={`${t('consumerLending:termsOfServiceUrl')}#credit-check`}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
        color={linkColor}
      />
    ),
    consent: (
      <TermLink
        key='payment-options-consent'
        fontFace='CashSansMono'
        href={`${t('consumerLending:termsOfServiceUrl')}#e-sign`}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
        color={linkColor}
      />
    ),
    creditGuide: (
      <TermLink
        key='payment-options-credit-guide'
        fontFace='CashSansMono'
        href={t('consumerLending:creditGuide')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
        color={linkColor}
      />
    ),
    creditReportingCollectionNotice: (
      <TermLink
        key='payment-options-credit-reporting-collection-notice'
        fontFace='CashSansMono'
        href={t('consumerLending:creditReportingCollectionNotice')}
        onClick={sendAnalyticsEvent}
        testNameSpace='payment-types-term'
        color={linkColor}
      />
    ),
  }

  return !openExistingFacility && selectedPaymentType === PaymentType.PCL ? (
    <div className={designLanguageStyles.termsWrapper}>
      <Text color='Gray40' size={isArcadeDesignLanguage ? 'XXS' : 'XS'} fontFace='CashSansMono'>
        <Trans i18nKey='consumerLending:paymentOptions:terms' components={components} />
      </Text>
    </div>
  ) : null
}
